var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lunchMenu"},[_c('Content',_vm._l((_vm.days),function(day,key){return _c('p',{key:key,domProps:{"innerHTML":_vm._s(("<b>" + day + "</b><br>" + (_vm.menu[key])))}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }